import { CheckOutlined, Close } from "@mui/icons-material";
import { Box, IconButton, Menu, useTheme } from "@mui/material";
import { FC } from "react";
import { useLocalization } from "../../hooks/useLocalization";
import { MinSessionDurationField } from "./MinSessionDurationField";

interface MinSessionDurationMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  draft: string;
  onDraftChange: (draft: string) => void;
  handleCancel: () => void;
  handleApply: () => void;
}

export const MinSessionDurationMenu: FC<MinSessionDurationMenuProps> = ({
  anchorEl,
  open,
  handleClose,
  draft,
  onDraftChange,
  handleCancel,
  handleApply,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  const actionButtonSx = {
    height: 28,
    width: 28,
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: theme.colors.secondary[1],
    },
  };

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      onClose={handleClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            overflow: "hidden",
          },
        },
      }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          gap: 0.5,
          px: 1,
          py: 0.5,
        }}
      >
        <MinSessionDurationField
          draft={draft}
          onDraftChange={onDraftChange}
          onSubmit={handleApply}
        />
        <IconButton
          aria-label={t("components.filterSelect.apply")}
          onClick={handleApply}
          sx={actionButtonSx}
        >
          <CheckOutlined
            sx={{ color: theme.colors.primary[5], fontSize: 18 }}
          />
        </IconButton>
        <IconButton
          aria-label={t("components.filterSelect.cancel")}
          onClick={handleCancel}
          sx={actionButtonSx}
        >
          <Close sx={{ color: theme.colors.secondary[5], fontSize: 18 }} />
        </IconButton>
      </Box>
    </Menu>
  );
};
